import {
  Avatar,
  Fab,
  Fade,
  FormControl,
  IconButton,
  Paper,
  Slide,
  TextField,
  Typography } from '@material-ui/core';
import LongMenu from '../share/LongMenu';
import { withStyles } from '@material-ui/core/styles';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import Search from '@material-ui/icons/Search';
import React from 'react';
import { withUsuario } from '../../contexts/UsuarioContext';
import MUIDataTable from 'mui-datatables';
import { Link } from 'react-router-dom';
import SaudeCaixaApi from '../../api/SaudeCaixaApi';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VariantSnackbar from '../share/VariantSnackbar';
import DialogErrosDemonstrativos from './DialogErrosDemonstrativos';
import ToolbarArquivoSelect from './ToolbarArquivoSelect';
import FullScreenDetalheArquivo from './FullScreenDetalheArquivo';

const styles = theme => ({
  root: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
  container: {
    display: 'block',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 220,
  },
  textField: {
    marginLeft: theme.spacing(1),
    width: 450,
  },
  button: {
    marginLeft: theme.spacing(2),
  },
  searchIcon: {
    marginLeft: theme.spacing(1),
  },
  input: {
    margin: theme.spacing(1),
  },
  link: {
    textDecoration: 'none',
  },
  body: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  avatar: {
    marginLeft: '20px'
  },
  tableRowCancelado: {
    backgroundColor: '#f2dede',
  },
  fontTable: {
    fontSize: 12
  },
});
class CalculoCoparticipacaoCaixa extends React.Component {
  saudeCaixaApi = new SaudeCaixaApi();
  state = {
    arquivos: [],
    codArquivoSelected: '',
    nomArquivoSelected: '',
    fetching: false,
    buscarDisabled: true,
    snackOpen: false,
    snackVariant: 'success',
    snackHorizontal: 'right',
    snackMessage: '',
    sucesso: true,
    arquivosSemErros: [],
    openFullScreen: false,
    openDialogValidacao: false,
    dialogTitle: '',
    dialogContent: [],
    anchorEl: null,
  }
  componentDidMount = async () => {
    this.setState({fetching: true});
    await this.consultarArquivosNaoPagos();
    this.setState({fetching: false});
  }
  consultarArquivosNaoPagos = async () => {
    this.setState({fetching: true});
    let arquivos = await this.saudeCaixaApi.consultarArquivos(this.state.codArquivoSelected === '' ? 0 : this.state.codArquivoSelected, 'N');
    this.setState({arquivos: arquivos, fetching: false});
  }
  handleChangeTextField = event => {
    var valorNovo = event.target.value.replace(/[^\d.-/-]/g, '').substring(0, 6);
    this.setState({ [event.target.name]: valorNovo, buscarDisabled: event.target.value === '' });
  };
  handleClickBuscar = async (event) => {
    event.preventDefault();
    await this.consultarArquivosNaoPagos();
  }
  onOperacaoFinalizadaDialog = async (result) => {
    if (result === undefined || result === null) {
      this.setState({snackOpen: true, snackMessage: 'Não foi possível realizar a operação.', fetching: false, sucesso: false});
    } else {
      this.setState({openDialogValidacao: true,
        dialogContent: result.registrosComErros,
        dialogTitle: result.msgRetornoResumida,
        demonstrativosSemErros: result.registrosSemErros,
        fetching: false,
        sucesso: false});
    }
    this.setState({fetching: false, codArquivoSelected: ''});
    await this.consultarArquivosNaoPagos();
  }
  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  }
  handleCloseDialogValidacao = () => {
    this.setState({ openDialogValidacao: false });
  };
  handleClickToolBar = () => {
    // this.setState({ fetching: true });
  }
  handleClickMenu = (event, tableMeta) => {
    this.setState({ anchorEl: event.currentTarget,
      codArquivoSelected: this.state.arquivos[tableMeta.rowIndex][0],
      nomArquivoSelected: this.state.arquivos[tableMeta.rowIndex][1] });
  }

  handleCloseMenu = () => {
    this.setState({ anchorEl: null });
  }

  handleChangeMenu = (index) => {
    this.setState({anchorEl: null});
    if (index === 0) {
      this.setState({openFullScreen: true});
    }
  }
  handleCloseFullScreen = async () => {
    this.setState({ openFullScreen: false });
  };
  render () {
    const options = {
      customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
        <ToolbarArquivoSelect
          handleClickToolBar={this.handleClickToolBar}
          selectedRows={selectedRows}
          displayData={displayData}
          setSelectedRows={setSelectedRows}
          onOperacaoFinalizada={this.onOperacaoFinalizadaDialog}
        />
      ),
      print: false,
      download: false,
      selectableRows: 'multiple',
      filterType: 'dropdown',
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 10,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline', fontFamily: 'Roboto'}}>arquivo(s) selecionada(s)</Typography>,
        },
      }
    };
    const columns = [
      {
        name: 'Sequencial',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Nome',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'GED',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Qtd. Registros',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'qtd importados',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'qtd rejeitados',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Total Autorizado',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        },
      },
      {
        name: 'total importado',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'total rejeitado',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },

      {
        name: 'Data Importação',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'usuario importacao',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'ind copart cobrada',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Ações',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            let options = [
              {
                index: 0,
                icon: <VisibilityIcon />,
                primaryText: 'Ver Detalhes...',
                visible: true,
                disabled: false
              },
            ];
            return (
              <LongMenu
                menuOptions={options}
                anchorEl={this.state.anchorEl}
                handleClick={this.handleClickMenu}
                handleChange={this.handleChangeMenu}
                handleClose={this.handleCloseMenu}
                selectedItem={tableMeta} />
            );
          },
        }
      },
    ];

    const { classes } = this.props;
    const { fetching, arquivos } = this.state;
    const path = this.props.previousPath;

    return (
      <React.Fragment>
        <Link to={path} className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='h5'>Arquivos Saúde Caixa - Cálculo de Coparticipação (Arquivos de Faturamento Não Lançados em Folha)</Typography>
              {arquivos && <Avatar className={classes.avatar}>{arquivos.length}</Avatar>}
            </Paper>
          </Slide>
        </Link>
        <Paper className={classes.root} elevation={1}>
          <form className={classes.container} noValidate>
            <FormControl className={classes.formControl}>
              <TextField
                value={(this.state.codArquivoSelected === null || this.state.codArquivoSelected === undefined) ? '' : this.state.codArquivoSelected}
                className={classes.textField}
                margin='dense'
                id='codArquivoSelected'
                name='codArquivoSelected'
                placeholder='Pesquise pelo Número...'
                fullWidth
                onChange={this.handleChangeTextField}
              />
            </FormControl>
            <Fab
              variant='extended'
              title='Consultar'
              type='submit'
              onTouchStart={this.handleClickBuscar}
              onClick={this.handleClickBuscar}
              className={classes.button}>
              <Search className={classes.searchIcon} />
              Buscar
            </Fab>
          </form>
        </Paper>
        {fetching ? <LinearProgressBlockScreen />
          : <Fade timeout={1000} in>
            <Paper className={classes.body} elevation={1}>
              <MUIDataTable
                data={arquivos}
                columns={columns}
                options={options}
              />
            </Paper>
          </Fade>
        }
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
        {this.state.openDialogValidacao &&
          <DialogErrosDemonstrativos
            open={this.state.openDialogValidacao}
            handleClose={this.handleCloseDialogValidacao}
            erros={this.state.dialogContent}
            titulo={this.state.dialogTitle}
            demonstrativosSemErros={this.state.demonstrativosSemErros}
            nomeEntidade={'Arquivo'}
            mensagemComplementar={'foi(ram) calculado(s) com sucesso.'}
          />}
        {this.state.openFullScreen &&
        <FullScreenDetalheArquivo
          open={this.state.openFullScreen}
          handleClose={this.handleCloseFullScreen}
          codArquivo={this.state.codArquivoSelected}
          nomeArquivo={this.state.nomArquivoSelected}
        />}
      </React.Fragment>
    );
  }
}
export default withUsuario((withStyles(styles)(CalculoCoparticipacaoCaixa)));
